<template>
  <div class="fts-formula-display">
    <fts-tippy v-if="tooltip">
      <div
        slot="trigger"
        v-html="content"
        class="formula-display formula-display--toggle"
        :class="{ 'formula-display--nowrap': noWrap }"
      ></div>
      <div slot="content" v-html="content" class="formula-display"></div>
    </fts-tippy>

    <div
      v-html="content"
      class="formula-display"
      :class="{ 'formula-display--nowrap': noWrap }"
      v-else
    ></div>
  </div>
</template>

<script>
import FTSTippy from "../elements/FTSTippy";
import commons from "../commons/commons";

var prepareVariables = function (information, vm, variableType) {
  let informationPart = information.map(function (x) {
    let moduleName = '';
    if(x.connectionId) {
      let moduleItem = vm.getModule(x.connectionId.toString())
      if(moduleItem) {
        moduleName = moduleItem.name;
      } else {
        moduleName = x.connection;
      }
    }

    return {
      fieldName: x.fieldName,
      type: x.type,
      name: x.displayName,
      fields: x.fields,
      moduleId: x.connectionId ? x.connectionId.toString() : null,
      moduleName: moduleName,
    };
  });

  let systemPart = [
    {
      fieldName: "documentId",
      name: "Document ID",
      system: true,
      type: 0,
    },
    {
      fieldName: "createdBy",
      name: "Created By",
      system: true,
      type: 0,
    },
    {
      fieldName: "createdDate",
      name: "Created Date",
      system: true,
      type: 5,
    },
    {
      fieldName: "lastChangeBy",
      name: "Last Change By",
      system: true,
      type: 0,
    },
    {
      fieldName: "lastChangeDate",
      name: "Last Change Date",
      system: true,
      type: 5,
    },
    {
      fieldName: "state",
      name: "State",
      system: true,
      type: 5,
    },
  ];

  let constants = [
    // {
    //     fieldName: 'today',
    //     name: 'Today',
    //     constant: true,
    // },
    // {
    //     fieldName: 'tomorrow',
    //     name: 'Tomorrow',
    //     constant: true,
    // }
  ];

  let aggregation = [
    {
      fieldName: "sum",
      name: "Sum",
      function: true,
    },
    {
      fieldName: "find",
      name: "Find",
      function: true,
    },
    {
      fieldName: "filter",
      name: "Filter",
      function: true,
    },
  ];

  // if (variableType == 14) {
  //   return [...aggregation];
  // }

  if (variableType == 36) {
    return [...informationPart, ...constants];
  }

  return [...systemPart, ...informationPart, ...constants];
};

export default {
  props: {
    noWrap: Boolean,
    tooltip: Boolean,
    variables: Array,
    formula: String,
    form: Object,
  },
  model: {
    prop: "formula",
  },
  components: {
    "fts-tippy": FTSTippy,
  },
  methods: {
    getModule(id) {
      if (id && this.$store.getters.workspaceModules) {
        const findModule = this.$store.getters.workspaceModules.find(
          (x) => x.id == id
        );
        if (findModule)
          return {
            id: findModule.id,
            name: findModule.name,
            emoji: findModule.emoji,
          };
      }
    },
    async updateDisplay(formula) {
      let re = /{{(?<fieldName>[\w|\.]*?)}}/g;

      try {
        let match = re.exec(formula);
        this.content = formula;
        let selection = _.cloneDeep(this.variables);
        selection = selection.concat(commons.formulaConstants);


        while (match != null) {
          let variablePaths = match[1].split(".");
          let variableValues = [];
          let source = selection;
          let lastVariable,
            previousVariable = null;
          for (let variablePath of variablePaths) {
            lastVariable = source.find((x) => x.fieldName == variablePath);

            if (
              !lastVariable &&
              previousVariable &&
              previousVariable.type == 14
            ) {
              source = prepareVariables(
                previousVariable.fields,
                this,
                previousVariable.type
              );
              lastVariable = source.find((x) => x.fieldName == variablePath);
            }

            variableValues.push(lastVariable);

            if (lastVariable && lastVariable.moduleId) {
              let data = await this.$store.dispatch("findVariable", {
                moduleId: lastVariable.moduleId,
              });

              if (lastVariable.informationId) {
                source = prepareVariables(
                  data.information.find(
                    (x) => x.id == lastVariable.informationId
                  )["fields"],
                  this,
                  lastVariable.type
                );
              } else {
                source = prepareVariables(
                  data.information,
                  this,
                  lastVariable.type
                );
              }
            } else if (lastVariable && lastVariable.type == 14) {
              source = prepareVariables(
                lastVariable.fields,
                this,
                lastVariable.type
              );
            }
          }
          //<i class="information-icon fts-icon-text"><\/i>&nbsp;
          this.content = this.content.replace(
            match[0],
            `<fts-i-unit contenteditable="false" field="${
              match[1]
            }"><i class="information-icon ${commons.informationIcon(
              variableValues[variableValues.length - 1].type
            )}"><\/i>&nbsp;${variableValues
              .map((x) => `<span class="variable">${x.name}</span>`)
              .join(
                "<span class='path-indicator'>'s</span>&nbsp;"
              )}</fts-i-unit>`
          );
          match = re.exec(formula);
        }
      } catch (err) {
        console.warn(`FTSExpression error: ${err}`);
      }
    },
  },
  watch: {
    async formula(newVal) {
      await this.updateDisplay(this.formula);
    },
  },
  data: () => ({
    regex:
      /<fts-i-unit contenteditable="false" field="(?<fieldName>.*?)">(?<display>.*?)<\/fts-i-unit>/g,
    content: "",
  }),
  async mounted() {
    let vm = this;
    await this.updateDisplay(this.formula);
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.formula-display {
  $py: 0.1rem;
  padding: $py 0;
  word-break: break-word;
  &.formula-display--toggle {
    cursor: default;
  }
  &.formula-display--nowrap {
    @include text-overflow-ellipsis;
  }
  .information-icon {
    color: var(--fts-gray-5);
    font-size: 90%;
  }
  .variable {
    color: #ffa726;
    font-weight: 600;
  }
  .path-indicator {
    color: var(--fts-gray-5);
  }
}
</style>